import './App.css';
import KL from './images/Keny.JPG';
import ComputerImg from './images/computer.jpg';
import CodingImg from './images/computer2.jpg';
import SFDCPDF from './files/SFDC.pdf';
import PSDImg from './images/psd.png';
import CEMImg1 from './images/Screenshot3.png';
import CEMImg2 from './images/Screenshot4.png';
import SFYImg1 from './images/sfy-s1.png';
import SFYImg2 from './images/sfy-s2.png';
import FFYImg1 from './images/ffy-s1.png';
import FFYImg2 from './images/ffy-s2.png';
import OCPPImg1 from './images/ocpp-s1.png';
import OCPPImg2 from './images/ocpp-s2.png';
import OCPPImg3 from './images/ocpp-s3.png';
import OCPPImg4 from './images/ocpp-s4.png';
import OCPPImg5 from './images/ocpp-s5.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faUnlock } from '@fortawesome/free-solid-svg-icons';
import { faMugSaucer } from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faSalesforce } from '@fortawesome/free-brands-svg-icons';
import React, {useEffect, useState} from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { aboutMe } from './data.js';
import { aboutMeSolution } from './data.js';
import { leftSkills } from './data.js';
import { rightSkills } from './data.js';
import { jobTitle } from './data.js';
import CountryQuery from './CountryQuery.js';

function App() {
    const [lightbox, setLightbox] = useState(null);

    useEffect(() => {
        function onKey(e) { if (e.key === 'Escape') setLightbox(null); }
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, []);

    const aboutMeContent = aboutMe.filter(active =>
        active.active === true
    );
    const aboutMeItems = aboutMeContent.map(active =>
        <div key={active.id}>{active.content}<p></p></div>
    );

    const aboutMeSolutionContent = aboutMeSolution.filter(active =>
        active.active === true
    );
    const aboutMeSolutionItems = aboutMeSolutionContent.map(active=>
        <div key={active.id} className="About-text-header">
            {active.title}
            <div key={`content_${active.id}`} className="About-text-content">{active.content}</div>
            <p></p>
        </div>
    );

    const leftSkillsContent = leftSkills.filter(active =>
        active.active === true
    );
    const leftSkillsItems = leftSkillsContent.map(active=>
        <div key={active.id} className="Skill-text-header">
            {active.title}
            <div key={`content_${active.id}`} className="Skill-text-content">{active.content}</div>
            <p></p>
        </div>
    );

    const rightSkillsContent = rightSkills.filter(active =>
        active.active === true
    );
    const rightSkillsItems = rightSkillsContent.map(active=>
        <div key={active.id} className="Skill-text-header">
            {active.title}
            <div key={`content_${active.id}`} className="Skill-text-content">{active.content}</div>
            <p></p>
        </div>
    );

    const jobTitleContent = jobTitle.filter(active =>
        active.active === true
    );
    const jobTitleItems = jobTitleContent.map(active=>
        <li key={active.id}>{active.title}</li>
    );

    useEffect(() => {
        const onPageLoad = () => {
            document.getElementById('MenuClose').style.display = 'none';
            document.getElementById('MenuBody').style.display = 'none';
            document.getElementById('MenuBottom').style.display = 'none';
            document.getElementById('MenuAlt1').style.display = 'none';
            document.getElementById('MenuAlt2').style.display = 'none';
            document.getElementById('MenuAlt3').style.display = 'none';
            document.getElementById('MenuAlt4').style.display = 'none';
            document.getElementById('MenuAlt5').style.display = 'none';

            document.getElementById('MenuOpen').onclick = function(){
                MenuExpand();
            };
            document.getElementById('MenuClose').onclick = function(){
                MenuClose();
            };

            if (window.innerWidth > 1000) {
                document.getElementById('PSD_image').width = window.innerWidth * 0.5;
            } else {
                document.getElementById('PSD_image').width = window.innerWidth * 0.9;
            }

            window.addEventListener("resize", reportWindowSize);
        }

        if (document.readyState === 'complete') {
            onPageLoad();
        } else {
            window.addEventListener('load', onPageLoad);
            // Remove the event listener when component unmounts
            return () => window.removeEventListener('load', onPageLoad);
        }
    },[]);

    function reportWindowSize() {
        if (window.innerWidth > 1000) {
            document.getElementById('PSD_image').width = window.innerWidth * 0.5;
        } else {
            document.getElementById('PSD_image').width = window.innerWidth * 0.9;
        }
    }

    function MenuExpand() {
        document.getElementById('MenuOpen').style.display = 'none';
        document.getElementById('MenuClose').style.display = '';
        document.getElementById('MenuTop').style.borderBottomLeftRadius = '0';
        document.getElementById('MenuTop').style.borderBottomRightRadius = '0';
        document.getElementById('MenuTop').style.borderBottom = 'none';
        document.getElementById('MenuBody').style.display = 'block';
        document.getElementById('MenuBottom').style.display = 'block';
    }

    function MenuClose() {
        document.getElementById('MenuOpen').style.display = '';
        document.getElementById('MenuClose').style.display = 'none';
        document.getElementById('MenuTop').style.borderBottomLeftRadius = '';
        document.getElementById('MenuTop').style.borderBottomRightRadius = '';
        document.getElementById('MenuTop').style.borderBottom = '';
        document.getElementById('MenuBody').style.display = 'none';
        document.getElementById('MenuBottom').style.display = 'none';
        document.getElementById('MenuAlt1').style.display = 'none';
        document.getElementById('MenuAlt2').style.display = 'none';
        document.getElementById('MenuAlt3').style.display = 'none';
        document.getElementById('MenuAlt4').style.display = 'none';
        document.getElementById('MenuAlt5').style.display = 'none';
    }

    function homeOver(e) {
        e.preventDefault();
        document.getElementById('MenuAlt').style.paddingTop = '25px';
        document.getElementById('MenuAlt1').style.display = '';
    }

    function homeOut(e) {
        e.preventDefault();
        document.getElementById('MenuAlt1').style.display = 'none';
    }

    function aboutOver(e) {
        e.preventDefault();
        document.getElementById('MenuAlt').style.paddingTop = '60px';
        document.getElementById('MenuAlt2').style.display = '';
    }

    function aboutOut(e) {
        e.preventDefault();
        document.getElementById('MenuAlt2').style.display = 'none';
    }

    function expOver(e) {
        e.preventDefault();
        document.getElementById('MenuAlt').style.paddingTop = '95px';
        document.getElementById('MenuAlt3').style.display = '';
    }

    function expOut(e) {
        e.preventDefault();
        document.getElementById('MenuAlt3').style.display = 'none';
    }

    function skillOver(e) {
        e.preventDefault();
        document.getElementById('MenuAlt').style.paddingTop = '130px';
        document.getElementById('MenuAlt4').style.display = '';
    }

    function skillOut(e) {
        e.preventDefault();
        document.getElementById('MenuAlt4').style.display = 'none';
    }

    function projectOver(e) {
        e.preventDefault();
        document.getElementById('MenuAlt').style.paddingTop = '165px';
        document.getElementById('MenuAlt5').style.display = '';
    }

    function projectOut(e) {
        e.preventDefault();
        document.getElementById('MenuAlt5').style.display = 'none';
    }

    function homeScroll(e) {
        e.preventDefault();
        document.getElementById('header').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        MenuClose();
    }

    function aboutMeScroll(e) {
        e.preventDefault();
        document.getElementById('AboutDiv').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        MenuClose();
    }

    function expScroll(e) {
        e.preventDefault();
        document.getElementById('ExpDiv').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        MenuClose();
    }

    function skillScroll(e) {
        e.preventDefault();
        document.getElementById('SkillDiv').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        MenuClose();
    }

    function projectScroll(e) {
        e.preventDefault();
        document.getElementById('ProjectDiv').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        MenuClose();
    }


  return (
    <>
    <div className="App">
        <div className="Menu-top-div" id="MenuTop">
            <a href="#0" className="Menu-link"><FontAwesomeIcon icon={faBars} size="lg" id="MenuOpen" /></a>
            <a href="#0" className="Menu-link"><FontAwesomeIcon icon={faXmark} size="lg" id="MenuClose" /></a>
        </div>
        <div className="Menu-body-div" id="MenuBody">
            <ul className="Menu-ul">
                <li><a href="#0" className="Menu-link" onClick={homeScroll} onMouseOver={homeOver} onMouseOut={homeOut}><FontAwesomeIcon icon={faHome} size="lg" /></a></li>
                <li><a href="#0" className="Menu-link" onClick={aboutMeScroll} onMouseOver={aboutOver} onMouseOut={aboutOut}><FontAwesomeIcon icon={faUser} size="lg" /></a></li>
                <li><a href="#0" className="Menu-link" onClick={expScroll} onMouseOver={expOver} onMouseOut={expOut}><FontAwesomeIcon icon={faUnlock} size="lg" /></a></li>
                <li><a href="#0" className="Menu-link" onClick={skillScroll} onMouseOver={skillOver} onMouseOut={skillOut}><FontAwesomeIcon icon={faThumbsUp} size="lg" /></a></li>
                <li><a href="#0" className="Menu-link" onClick={projectScroll} onMouseOver={projectOver} onMouseOut={projectOut}><FontAwesomeIcon icon={faMugSaucer} size="lg" /></a></li>
            </ul>
        </div>
        <div className="Menu-alt-div" id="MenuAlt">
            <ul className="Alt-ul">
                <li className="Alt-li" id="MenuAlt1">HOME</li>
                <li className="Alt-li" id="MenuAlt2">ABOUT ME</li>
                <li className="Alt-li" id="MenuAlt3">EXPERIENCE</li>
                <li className="Alt-li" id="MenuAlt4">SKILLS</li>
                <li className="Alt-li" id="MenuAlt5">SHOWCASE</li>
            </ul>
        </div>
        <div className="Menu-bottom-div" id="MenuBottom">
        </div>
        <header className="App-header">
            <div id="header"></div>

<BrowserView>
                <table className="Header-table">
                    <tbody>
                    <tr>
                        <td width="50%" className="Header-tableTd">
                            <table width="100%">
                                <tbody>
                                <tr>
                                    <td width="30%">&nbsp;</td>
                                    <td>
                                        <div className="Header-leftDiv">
                                            <img src={KL} className="Img-KL" alt="Keny Lin"/>
                                            <br/><br/>
                                            <div className="Profile-name">
                                                KENY LIN
                                            </div>
                                            <div className="Profile-title">
                                                <ul>{jobTitleItems}</ul>
                                            </div>
                                        </div>
                                    </td>
                                    <td>&nbsp;</td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                        <td className="Header-tableTd">
                            <div className="Profile-header">
                                Career Goal
                            </div>
                            <br/>
                            <div className="Profile-content">
                                Product and engineering leader with 22+ years of experience delivering EV charging
                                solutions, digital platforms, and enterprise systems across North America and Asia.<br/><br/>
                                Deep end-to-end understanding of EV charging ecosystems — from OCPP protocol flows,
                                CTEP/DMS pricing compliance, and charger diagnostics, to CPO/OEM operations, network
                                interoperability, and customer-facing platform design. Bridges technical depth with
                                operational and business know-how to drive reliable, compliant, and scalable charging
                                infrastructure.<br/>&nbsp;
                            </div>
                            <hr className="Profile-hr"/>
                            <div className="Profile-contact">
                                <table className="Profile-contact-table">
                                    <tbody>
                                    <tr>
                                        <td width="10%" className="Profile-contact-td">
                                            <FontAwesomeIcon icon={faLocationDot}/>
                                        </td>
                                        <td className="Profile-contact-td2">
                                            San Francisco Bay Area
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="Profile-contact-td">
                                            <FontAwesomeIcon icon={faLinkedin}/>
                                        </td>
                                        <td className="Profile-contact-td2">
                                            <a className="App-link" target="_blank"
                                               href="https://www.linkedin.com/in/kenylin/"
                                               rel="noreferrer">https://www.linkedin.com/in/kenylin/</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="Profile-contact-td">
                                            <FontAwesomeIcon icon={faSalesforce}/>
                                        </td>
                                        <td className="Profile-contact-td2">
                                            <a className="App-link" target="_blank"
                                               href="https://www.salesforce.com/trailblazer/kenylin"
                                               rel="noreferrer">https://www.salesforce.com/trailblazer/kenylin/</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="Profile-contact-td">
                                            <FontAwesomeIcon icon={faGithub}/>
                                        </td>
                                        <td className="Profile-contact-td2">
                                            <a className="App-link" target="_blank" href="https://github.com/Kenytw"
                                               rel="noreferrer">https://github.com/Kenytw</a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </BrowserView>
            <MobileView>
                <table className="Header-table">
                    <tbody>
                    <tr>
                        <td width="100%" className="Header-tableTd">
                            <table width="100%">
                                <tbody>
                                <tr>
                                    <td width="5%">&nbsp;</td>
                                    <td>
                                        <div className="Header-leftDiv-mobile">
                                            <img src={KL} className="Img-KL" alt="Keny Lin"/>
                                            <br/><br/>
                                            <div className="Profile-name">
                                                KENY LIN
                                            </div>
                                            <div className="Profile-title">
                                                <ul>{jobTitleItems}</ul>
                                            </div>
                                        </div>
                                    </td>
                                    <td width="5%">&nbsp;</td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td className="Header-tableTd">
                            <div className="Profile-header">
                                Career Goal
                            </div>
                            <br/>
                            <div className="Profile-content">
                                Product and engineering leader with 22+ years of experience delivering EV charging
                                solutions, digital platforms, and enterprise systems across North America and Asia.<br/><br/>
                                Deep end-to-end understanding of EV charging ecosystems — from OCPP protocol flows,
                                CTEP/DMS pricing compliance, and charger diagnostics, to CPO/OEM operations, network
                                interoperability, and customer-facing platform design. Bridges technical depth with
                                operational and business know-how to drive reliable, compliant, and scalable charging
                                infrastructure.<br/>&nbsp;
                            </div>
                            <hr className="Profile-hr"/>
                            <div className="Profile-contact">
                                <table className="Profile-contact-table">
                                    <tbody>
                                    <tr>
                                        <td width="10%" className="Profile-contact-td">
                                            <FontAwesomeIcon icon={faLocationDot}/>
                                        </td>
                                        <td className="Profile-contact-td2">
                                            San Francisco Bay Area
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="Profile-contact-td">
                                            <FontAwesomeIcon icon={faLinkedin}/>
                                        </td>
                                        <td className="Profile-contact-td2">
                                            <a className="App-link" target="_blank"
                                               href="https://www.linkedin.com/in/kenylin/"
                                               rel="noreferrer">https://www.linkedin.com/in/kenylin/</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="Profile-contact-td">
                                            <FontAwesomeIcon icon={faSalesforce}/>
                                        </td>
                                        <td className="Profile-contact-td2">
                                            <a className="App-link" target="_blank"
                                               href="https://www.salesforce.com/trailblazer/kenylin"
                                               rel="noreferrer">https://www.salesforce.com/trailblazer/kenylin/</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="Profile-contact-td">
                                            <FontAwesomeIcon icon={faGithub}/>
                                        </td>
                                        <td className="Profile-contact-td2">
                                            <a className="App-link" target="_blank" href="https://github.com/Kenytw"
                                               rel="noreferrer">https://github.com/Kenytw</a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </MobileView>
            <div className="Down-div">
                This website was built using the <b>React</b> framework, with <b>JavaScript</b> and <b>CSS</b>. More
                case studies can be found at the bottom of the page.
                <br/><br/><a href="#0" className="Menu-link" onClick={projectScroll}><FontAwesomeIcon icon={faAngleDown}
                                                                                                      size="lg" bounce/></a>
            </div>
        </header>
        <div className="About-div">
            <div className="About-header" id="AboutDiv">ABOUT ME</div>
            <BrowserView>
                <table className="About-table">
                    <tbody>
                    <tr>
                        <td width="50%" className="About-img-td">
                            <img src={ComputerImg} className="Img-About" alt=""/>
                        </td>
                        <td className="About-text-td">
                            {aboutMeItems}
                        </td>
                    </tr>
                    <tr>
                        <td className="About-text-td">
                            {aboutMeSolutionItems}
                        </td>
                      <td className="About-img-td">
                          <img src={CodingImg} className="Img-About" alt="" />
                      </td>
                  </tr>
              </tbody>
            </table>
            </BrowserView>
            <MobileView>
                <table className="About-table">
              <tbody>
                  <tr>
                      <td width="50%" className="About-img-td">
                          <img src={ComputerImg} className="Img-About" alt="" />
                      </td>
                  </tr>
                  <tr>
                      <td className="About-text-td">
                          {aboutMeItems}
                      </td>
                  </tr>
                  <tr>
                      <td className="About-img-td">
                          <img src={CodingImg} className="Img-About" alt="" />
                      </td>
                  </tr>
                  <tr>
                      <td className="About-text-td">
                          {aboutMeSolutionItems}
                      </td>
                  </tr>
              </tbody>
            </table>
            </MobileView>
        </div>
        <div className="Exp-div">
            <div className="Exp-header" id="ExpDiv">EXPERIENCE</div>
            <table className="Exp-table">
                <tbody>
                    <tr>
                        <td className="Exp-name" width="20%">Dec 2024 - Present</td>
                        <td className="Exp-name">StarCharge America – Fremont, CA</td>
                    </tr>
                    <tr>
                        <td className="Exp-title">Engineering Manager</td>
                        <td className="Exp-detail">
                            <ul>
                                <li>Lead EV charging platform strategy and technical operations supporting AC Level 2 and DC Fast Charging deployments across North America.</li>
                                <li>Defined and delivered OCPP backend platform capabilities including CTEP compliance, idle fee management, session cost calculation, and DataTransfer workflows.</li>
                                <li>Integrated Payter and Nayax payment platforms to support seamless charging transactions and customer payment flows.</li>
                                <li>Served as senior escalation lead for charger incidents involving firmware, networking, hardware, and backend communication failures.</li>
                                <li>Implemented Salesforce Service Cloud workflows and SLA tracking, reducing average ticket resolution time by 45%.</li>
                                <li>Provided technical and business consultation to CPO partners, supporting charger deployment strategy, integration planning, and operational readiness.</li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
            <hr className="Exp-hr" /><p></p>
            <table className="Exp-table">
                <tbody>
                    <tr>
                        <td className="Exp-name" width="20%">Jun 2023 - Nov 2024</td>
                        <td className="Exp-name">Freelancer – Fremont, CA</td>
                    </tr>
                    <tr>
                        <td className="Exp-title">Salesforce Administrator &amp; Full-Stack Web Developer</td>
                        <td className="Exp-detail">
                             <ul>
                                 <li>Designed and deployed customer-facing SaaS applications with integrated APIs, databases, and responsive UI/UX frameworks.</li>
                                 <li>Delivered Salesforce administration, workflow automation, and reporting solutions to improve CRM operations and customer engagement.</li>
                                 <li>Consulted on ERP, HRIS, and cloud platform integrations to streamline business operations and improve scalability.</li>
                             </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
            <hr className="Exp-hr" /><p></p>
            <table className="Exp-table">
                <tbody>
                    <tr>
                        <td className="Exp-name" width="20%">Oct 2013 - May 2023</td>
                        <td className="Exp-name">ASUS North America – Fremont, CA</td>
                    </tr>
                    <tr>
                        <td className="Exp-title">Director of IT and Operations</td>
                        <td className="Exp-detail">
                            <ul>
                                <li>Directed enterprise applications and digital operations supporting Finance, HR, Logistics, Marketing, Customer Service, and Engineering organizations.</li>
                                <li>Managed Salesforce CRM, Oracle EBS, BI platforms, and SaaS integrations to improve operational efficiency and business visibility.</li>
                                <li>Reduced operational costs by 43% through automation, infrastructure optimization, and vendor consolidation.</li>
                                <li>Re-engineered business workflows reducing manual effort by 80% and process lead time by 60%.</li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
            <hr className="Exp-hr" /><p></p>
            <table className="Exp-table">
                <tbody>
                    <tr>
                        <td className="Exp-name" width="20%">Nov 2008 - Oct 2013</td>
                        <td className="Exp-name">ASUS Tek Inc. – Taipei, Taiwan</td>
                    </tr>
                    <tr>
                        <td className="Exp-title">Project Specialist</td>
                        <td className="Exp-detail">
                            <ul>
                                <li>Managed Salesforce CRM implementation projects, BI reporting initiatives, and business process optimization programs.</li>
                                <li>Coordinated cross-functional stakeholders to align product capabilities, reporting needs, and operational goals.</li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="Exp-header" id="ExpDiv">EDUCATION</div>
            <table className="Exp-table">
                <tbody>
                    <tr>
                        <td className="Exp-name" width="20%">Sep 1996 - Jun 2000</td>
                        <td className="Exp-name">National Central University - Taoyuan, Taiwan</td>
                    </tr>
                    <tr>
                        <td className="Exp-title">Bachelor of Science</td>
                        <td className="Exp-detail">
                            <b>MIS (Management Information Systems)</b>
                        </td>
                    </tr>
                </tbody>
            </table>
            <hr className="Exp-hr" /><p></p>
            <table className="Exp-table">
                <tbody>
                    <tr>
                        <td className="Exp-name" width="20%">2024</td>
                        <td className="Exp-name">Salesforce</td>
                    </tr>
                    <tr>
                        <td className="Exp-title">Salesforce Certified Administrator</td>
                        <td className="Exp-detail">
                            <b>Credential ID: 4279755</b>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p></p>&nbsp;
        </div>
        <div className="Skill-div">
            <div className="Skill-header" id="SkillDiv">SKILLS & ABILITIES</div>
            <BrowserView>
            <table className="Exp-table">
                <tbody>
                    <tr>
                        <td width="50%" className="Skill-td">{leftSkillsItems}</td>
                        <td className="Skill-td">{rightSkillsItems}</td>
                    </tr>
                </tbody>
            </table>
            </BrowserView>
            <MobileView>
                <table className="Exp-table">
                <tbody>
                    <tr>
                        <td className="Skill-td">{leftSkillsItems}</td>
                    </tr><tr>
                        <td className="Skill-td">{rightSkillsItems}</td>
                    </tr>
                </tbody>
            </table>
            </MobileView>
        </div>
        <div className="Project-div">
            <div className="Project-header" id="ProjectDiv">SHOWCASE</div>
            <table className="Project-table">
                <tbody>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-header">
                            EV Charging Station Management Platform
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-content">
                            <p>A full-stack EV charging management platform supporting OCPP 1.6 and 2.0.1 protocols with California CTEP/DMS pricing compliance. The backend runs three separate processes — a FastAPI REST server, an OCPP 1.6 WebSocket server, and an OCPP 2.0.1 WebSocket server — communicating via Redis pub/sub. Features include real-time charger monitoring, remote start/stop, multi-language pricing display, idle fee management, and offline transaction recovery. Built with Python FastAPI, React/Vite, PostgreSQL, Redis, and Docker.</p>
                            <p>Link: <a
                                href="https://ocpp.starchargeamericas.com"
                                className="Download-link" target="_blank"
                                rel="noreferrer">ocpp.starchargeamericas.com</a></p>
                            <div className="Screenshot-strip">
                                <img src={OCPPImg1} className="Screenshot-img" alt="" onClick={() => setLightbox(OCPPImg1)} />
                                <img src={OCPPImg2} className="Screenshot-img" alt="" onClick={() => setLightbox(OCPPImg2)} />
                                <img src={OCPPImg3} className="Screenshot-img" alt="" onClick={() => setLightbox(OCPPImg3)} />
                                <img src={OCPPImg4} className="Screenshot-img" alt="" onClick={() => setLightbox(OCPPImg4)} />
                                <img src={OCPPImg5} className="Screenshot-img" alt="" onClick={() => setLightbox(OCPPImg5)} />
                            </div>
                        </div>
                        <hr className="Project-hr"/>
                        <p></p>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-header">
                            Gen AI Website - food for you
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-content">
                            <p>An AI-powered food discovery platform that surfaces trending local dishes and nearby restaurants based on your location and search radius. Generative AI identifies location-specific foods and resolves real restaurants via the Overpass/OpenStreetMap API. Users can like favorites and save them with Google login — all backed by React, Tailwind CSS, Express.js, and MongoDB.</p>
                            <p>Link: <a
                                href="https://food.kenylin.com"
                                className="Download-link" target="_blank"
                                rel="noreferrer">food for you</a></p>
                            <div className="Screenshot-strip">
                                <img src={FFYImg1} className="Screenshot-img" alt="" onClick={() => setLightbox(FFYImg1)} />
                                <img src={FFYImg2} className="Screenshot-img" alt="" onClick={() => setLightbox(FFYImg2)} />
                            </div>
                        </div>
                        <hr className="Project-hr"/>
                        <p></p>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-header">
                            Gen AI Website - song for you
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-content">
                            <p>An AI-powered music discovery platform that curates personalized song recommendations based on your age, language, and genre preferences. Generative AI powers the recommendations, fetching real tracks with album art from the Spotify API and offering playback links via YouTube or Apple Music. Hit "Next Round" for a fresh set of picks or "Surprise Me" for a random discovery — all backed by React, Tailwind CSS, Express.js, and MongoDB.</p>
                            <p>Link: <a
                                href="https://song.kenylin.com"
                                className="Download-link" target="_blank"
                                rel="noreferrer">song for you</a></p>
                            <div className="Screenshot-strip">
                                <img src={SFYImg1} className="Screenshot-img" alt="" onClick={() => setLightbox(SFYImg1)} />
                                <img src={SFYImg2} className="Screenshot-img" alt="" onClick={() => setLightbox(SFYImg2)} />
                            </div>
                        </div>
                        <hr className="Project-hr"/>
                        <p></p>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-header">
                            Chrome Extension - Message Reader
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-content">
                            <p>This Chrome extension displays messages from an organization's admin to users. The
                                extension
                                shows a badge icon when there are unread messages, provides a popup interface for users
                                to
                                view messages, and allows users to mark messages as read. It also stores message history
                                locally and supports background message checking.</p>
                            <p><FontAwesomeIcon icon={faGithub}/> <a
                                href="https://github.com/Kenytw/Chrome_Extension_Message_Reader"
                                className="Download-link" target="_blank"
                                rel="noreferrer">Repo link</a></p>
                            <div className="Screenshot-strip">
                                <img src={CEMImg1} className="Screenshot-img" alt="" onClick={() => setLightbox(CEMImg1)} />
                                <img src={CEMImg2} className="Screenshot-img" alt="" onClick={() => setLightbox(CEMImg2)} />
                            </div>
                        </div>
                        <hr className="Project-hr"/>
                        <p></p>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-header">
                            React Query + GraphQL Request
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-content">
                            <p>Public GraphQL API for information about countries. (API is provided by <a
                                className="Download-link" target="_blank" rel="noreferrer"
                                href="https://trevorblades.com/">https://trevorblades.com/</a>.)</p>
                            <CountryQuery></CountryQuery>
                        </div>
                        <hr className="Project-hr"/>
                        <p></p>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-header">
                            Salesforce Administrator / Developer / Analyst / CRM Consultant
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-content">
                            <p>Salesforce Administrator, Developer, and Consultant with 12 years of experience helping
                                organizations design and implement tailored Salesforce solutions. Successfully
                                collaborated with ASUS North America to build and optimize Account, Lead, and
                                Opportunity Management systems, as well as customized objects, flows, reports, and
                                dashboards. Expertise includes Sales Cloud, CPQ, Service Cloud, Marketing Cloud, and
                                Tableau CRM (Einstein Analytics).</p>
                            <p>Proficient in Salesforce configuration, including Workflow Automation, Process Builder,
                                App Builder, data management, security settings, and advanced reporting/dashboard
                                creation. Skilled in Salesforce development, such as Apex Triggers/Classes, Visualforce,
                                Lightning Components, and API integrations with middleware (e.g., MuleSoft). Led
                                solutions that significantly enhanced the Sales team’s efficiency, providing them with
                                improved visibility and a perfect-fit solution for their needs.</p>
                            <FontAwesomeIcon icon={faFilePdf}/> <a href={SFDCPDF} download className="Download-link"
                                                                   target="_blank" rel="noreferrer">Salesforce Screening
                            Test file</a>
                        </div>
                        <br/>
                        <hr className="Project-hr"/>
                        <p></p>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-header">
                            3d model animated based on human pose estimation
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="Project-td">
                        <div className="Project-text-content">
                            <p>Utilize a pre-trained Computer Vision model to analyze video footage and perform human
                                pose estimation. Based on the extracted pose data, trigger a 3D model to accurately
                                display the corresponding human pose in real-time.</p>
                            <p><FontAwesomeIcon icon={faGithub}/> <a
                                href="https://github.com/Kenytw/people-skeleton-detection---beta"
                                className="Download-link" target="_blank"
                                rel="noreferrer">Repo link</a></p>
                            <li>
                                The front-end is developed using <a rel='noreferrer' className="Download-link"
                                                                    target='_blank'
                                                                    href='https://react.dev/'>ReactJS</a>.
                            </li>
                            <li>
                                The 3D rendering on the front-end is powered by <a rel='noreferrer'
                                                                                   className="Download-link"
                                                                                   target='_blank'
                                                                                   href='https://threejs.org/'>Three.js</a>.
                            </li>
                            <li>
                                The back-end is implemented with <a rel='noreferrer' className="Download-link"
                                                                    target='_blank'
                                                                    href='https://flask.palletsprojects.com/en/2.3.x/'>Python
                                Flask</a>.
                            </li>
                            <li>
                                Object detection utilizes the <a rel='noreferrer' className="Download-link"
                                                                 target='_blank' href='https://docs.ultralytics.com/'>Ultralytics
                                YOLOv8 model</a>.
                            </li>
                            <li>
                                Pose and landmark detection are handled by the <a rel='noreferrer'
                                                                                  className="Download-link"
                                                                                  target='_blank'
                                                                                  href='https://developers.google.com/mediapipe'>MediaPipe
                                API</a>.
                            </li>
                            <li>
                                The 3D model used is the Stacy-rigged model, available on <a rel='noreferrer'
                                                                                             className="Download-link"
                                                                                             target='_blank'
                                                                                             href='https://www.turbosquid.com/3d-models/3d-stacy-resolution-games-model/535459'>TurboSquid</a>.
                            </li>
                            <br/><img src={PSDImg} alt="" id="PSD_image"></img>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <p>&nbsp;</p>
    </div>

    {/* Lightbox */}
    {lightbox && (
        <div className="Lightbox-overlay" onClick={() => setLightbox(null)}>
            <button className="Lightbox-close" onClick={() => setLightbox(null)}>✕</button>
            <img src={lightbox} className="Lightbox-img" alt="" onClick={e => e.stopPropagation()} />
        </div>
    )}
    </>
  );
}

export default App;
